import { Component, Input } from '@angular/core';
import { Warehouse } from "../../../../_shared/interfaces";
import {DatePipe, NgForOf, NgIf} from "@angular/common";
import {WarehouseStoreService} from "../../../../_shared/services";

@Component({
  selector: 'app-order-details-warehouse-short',
  standalone: true,
  imports: [
    NgIf,
    DatePipe,
    NgForOf
  ],
  templateUrl: './order-details-warehouse-short.component.html',
  styleUrl: './order-details-warehouse-short.component.sass'
})
export class OrderDetailsWarehouseShortComponent {
  warehouse: Warehouse[] = [];
  loading: boolean = true;

  @Input() projectId: string = '';
  @Input() jobId: number = 0;
  @Input() orderId: number = 0;
  @Input() positionId: number = 0;
  @Input() partId: number = 0;

  constructor(
    private waress: WarehouseStoreService,
  ) { }

  ngOnInit(): void {
    this.loadPositionsWarehouse(this.projectId, this.jobId, this.orderId, this.positionId, this.partId)
  }

  isIncoming(movementType: string): boolean {
    return movementType === 'incoming' || movementType === 'stock_init' || movementType === 'return_inbound';
  }

  loadPositionsWarehouse(projectId: string, jobId: number, orderId: number, position: number, part: number) {
    this.waress.getPositionsWarehouse(projectId, jobId, orderId, position, part).subscribe({
      next: data => {
        this.warehouse = data.object;
      },
      complete: () => {
        this.loading = false;
      },
      error: () => {
        return
      }
    })
  }
}
